<style scoped>
@import '@/assets/css/custom.css';

.cmd-page {
	--cmd-blue: #2a8fd7;
	--cmd-green: #2f9e44;
	--cmd-border: #e6e8ec;
	--cmd-muted: #8b93a7;
	--cmd-bg: #f5f6f8;
}

.cmd-shell {
	background: #fff;
	border: 1px solid var(--cmd-border);
	border-radius: 12px;
	overflow: hidden;
	min-height: calc(100vh - 180px);
	display: flex;
	flex-direction: column;
}

.cmd-toolbar {
	display: flex;
	flex-wrap: wrap;
	gap: 16px;
	align-items: flex-end;
	justify-content: flex-start;
	padding: 16px 18px;
	border-bottom: 1px solid var(--cmd-border);
	background: #fff;
}

.cmd-field label {
	display: block;
	font-size: 11px;
	font-weight: 700;
	letter-spacing: 0.04em;
	color: #6c757d;
	margin-bottom: 4px;
}

.cmd-vehicle-wrap {
	position: relative;
	flex: 0 1 360px;
	width: 360px;
	max-width: 100%;
	min-width: 240px;
}

.cmd-vehicle-input {
	width: 100%;
	height: 42px;
	border: 1px solid var(--cmd-border);
	border-radius: 8px;
	padding: 0 12px;
	font-size: 14px;
}

.cmd-toolbar-right {
	display: flex;
	flex-wrap: wrap;
	align-items: flex-end;
	gap: 14px;
	margin-left: auto;
}

.cmd-idle {
	margin-top: 4px;
	font-size: 12px;
	color: var(--cmd-muted);
	display: flex;
	align-items: center;
	gap: 6px;
}

.cmd-idle .dot {
	width: 8px;
	height: 8px;
	border-radius: 50%;
	background: #22c55e;
	display: inline-block;
}

.cmd-idle .dot.offline {
	background: #94a3b8;
}

.cmd-suggest {
	position: absolute;
	left: 0;
	right: 0;
	top: calc(100% + 4px);
	z-index: 20;
	background: #fff;
	border: 1px solid var(--cmd-border);
	border-radius: 8px;
	max-height: 220px;
	overflow-y: auto;
	box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
}

.cmd-suggest button {
	display: block;
	width: 100%;
	text-align: left;
	border: 0;
	background: transparent;
	padding: 10px 12px;
	font-size: 13px;
	border-bottom: 1px solid #f1f3f5;
}

.cmd-suggest button:hover {
	background: #fff7ed;
}

.cmd-history {
	flex: 0 0 auto;
}

.cmd-history select {
	height: 42px;
	min-width: 120px;
	border: 1px solid var(--cmd-border);
	border-radius: 8px;
	padding: 0 10px;
}

.cmd-stats {
	display: flex;
	gap: 10px;
	flex-wrap: wrap;
}

.cmd-stat {
	width: 64px;
	height: 54px;
	border-radius: 10px;
	border: 1px solid var(--cmd-border);
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	background: #fff;
}

.cmd-stat strong {
	font-size: 15px;
	line-height: 1;
	color: #334155;
}

.cmd-stat span {
	font-size: 10px;
	color: var(--cmd-muted);
	margin-top: 4px;
}

.cmd-chat {
	flex: 1;
	background: var(--cmd-bg);
	padding: 18px;
	overflow-y: auto;
	min-height: 420px;
	max-height: calc(100vh - 340px);
}

.cmd-empty {
	height: 100%;
	min-height: 320px;
	display: flex;
	align-items: center;
	justify-content: center;
	color: var(--cmd-muted);
	text-align: center;
	padding: 24px;
}

.cmd-card {
	background: #fff;
	border: 1px solid var(--cmd-border);
	border-radius: 12px;
	padding: 14px 16px;
	margin-bottom: 14px;
	max-width: 760px;
	box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.cmd-card.is-right {
	margin-left: auto;
	background: #f8fbff;
	border-color: #d6e8f7;
}

.cmd-card.is-right .cmd-footer {
	justify-content: flex-start;
	flex-direction: row-reverse;
}

.cmd-row {
	display: flex;
	gap: 10px;
	align-items: flex-start;
	margin-bottom: 10px;
}

.cmd-row:last-child {
	margin-bottom: 0;
}

.cmd-icon {
	width: 28px;
	height: 28px;
	border-radius: 50%;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	margin-top: 2px;
}

.cmd-icon.send {
	background: rgba(240, 122, 26, 0.12);
	color: var(--cmd-blue);
}

.cmd-icon.recv {
	background: rgba(47, 158, 68, 0.12);
	color: var(--cmd-green);
}

.cmd-icon.user {
	background: #eef2ff;
	color: #4f46e5;
}

.cmd-body {
	flex: 1;
	min-width: 0;
}

.cmd-text-send {
	color: var(--cmd-blue);
	font-weight: 600;
	font-size: 14px;
	word-break: break-word;
	white-space: pre-wrap;
}

.cmd-text-recv {
	color: var(--cmd-green);
	font-weight: 600;
	font-size: 14px;
	word-break: break-word;
	white-space: pre-wrap;
}

.cmd-meta {
	font-size: 12px;
	color: var(--cmd-muted);
	margin-top: 2px;
}

.cmd-user-name {
	font-weight: 700;
	color: #1f2937;
	font-size: 12px;
}

.cmd-ttl {
	font-size: 8px;
	font-weight: 600;
	color: #64748b;
	line-height: 1.2;
	margin-top: 2px;
}

.cmd-footer {
	display: flex;
	justify-content: flex-end;
	align-items: center;
	gap: 8px;
	margin-top: 8px;
	color: var(--cmd-muted);
	font-size: 12px;
}

.cmd-status-pill {
	display: inline-block;
	padding: 2px 8px;
	border-radius: 999px;
	font-size: 11px;
	font-weight: 600;
	text-transform: uppercase;
}

.cmd-status-pill.queued { background: #fff7ed; color: #c2410c; }
.cmd-status-pill.sent { background: #eff6ff; color: #1d4ed8; }
.cmd-status-pill.responded { background: #ecfdf5; color: #047857; }

.cmd-composer {
	border-top: 1px solid var(--cmd-border);
	padding: 14px 16px 16px;
	background: #fff;
}

.cmd-composer-row {
	display: flex;
	gap: 10px;
	align-items: center;
}

.cmd-composer input {
	flex: 1;
	height: 46px;
	border: 1px solid var(--cmd-border);
	border-radius: 10px;
	padding: 0 14px;
	font-size: 14px;
}

.cmd-send-btn {
	width: 46px;
	height: 46px;
	border: 0;
	border-radius: 10px;
	background: var(--cmd-blue);
	color: #fff;
	display: inline-flex;
	align-items: center;
	justify-content: center;
}

.cmd-send-btn:disabled {
	opacity: 0.55;
	cursor: not-allowed;
}

.cmd-hint {
	margin-top: 8px;
	font-size: 12px;
	color: var(--cmd-muted);
}
</style>

<template>
	<div class="cmd-page">
		<Breadcrumbs main="" title="Commands" />

		<div class="container-fluid">
			<div class="cmd-shell">
				<div class="cmd-toolbar">
					<div class="cmd-vehicle-wrap cmd-field">
						<label>VEHICLE / IMEI</label>
						<input
							class="cmd-vehicle-input"
							type="text"
							v-model="vehicleQuery"
							placeholder="Search IMEI or vehicle number..."
							@input="onVehicleQueryInput"
							@keydown.enter.prevent="selectExactImei"
							@focus="showSuggestions = suggestions.length > 0"
						/>
						<div class="cmd-idle" v-if="selectedImei">
							<span class="dot" :class="{ offline: !deviceOnline }"></span>
							<span>{{ idleLabel }}</span>
							<span v-if="selectedVehicleLabel"> · {{ selectedVehicleLabel }}</span>
							<span v-if="selectedDeviceModel"> · {{ selectedDeviceModel }}</span>
						</div>
						<div class="cmd-suggest" v-if="showSuggestions && suggestions.length">
							<button
								type="button"
								v-for="item in suggestions"
								:key="item.imei + '-' + (item.vehicle_number || '')"
								@click="selectVehicle(item)"
							>
								{{ item.imei }}
								<span v-if="item.vehicle_number"> | {{ item.vehicle_number }}</span>
								<span v-else> | No Vehicle</span>
							</button>
						</div>
					</div>

					<div class="cmd-toolbar-right">
						<div class="cmd-field cmd-history">
							<label>HISTORY</label>
							<select v-model="historyDays" @change="applyHistoryFilter">
								<option :value="1">1 Day</option>
								<option :value="3">3 Days</option>
								<option :value="7">7 Days</option>
							</select>
						</div>

						<div class="cmd-stats">
							<div class="cmd-stat" title="Queued">
								<strong>{{ counts.queued }}</strong>
								<span>Queued</span>
							</div>
							<div class="cmd-stat" title="Sent">
								<strong>{{ counts.sent }}</strong>
								<span>Sent</span>
							</div>
							<div class="cmd-stat" title="Responded">
								<strong>{{ counts.responded }}</strong>
								<span>Done</span>
							</div>
							<div class="cmd-stat" title="Total in view">
								<strong>{{ filteredLogs.length }}</strong>
								<span>Total</span>
							</div>
						</div>
					</div>
				</div>

				<div class="cmd-chat" ref="chatBox">
					<div class="cmd-empty" v-if="!selectedImei">
						<div>
							<strong>Select a vehicle / IMEI</strong>
							<div class="mt-1">Search above, then send commands in the chat box below.</div>
						</div>
					</div>

					<div class="cmd-empty" v-else-if="loadingLogs && !filteredLogs.length">
						Loading command history...
					</div>

					<div class="cmd-empty" v-else-if="!filteredLogs.length">
						<div>
							<strong>No commands in this history window</strong>
							<div class="mt-1">Send a command below. Responses appear here automatically.</div>
						</div>
					</div>

					<div
						class="cmd-card"
						:class="{ 'is-right': isPendingStatus(log.status) }"
						v-for="log in filteredLogs"
						:key="log.id || (log.command + '-' + (log.queued_at || log.command_sent_at || ''))"
					>
						<div class="cmd-row">
							<div class="cmd-icon send">
								<vue-feather type="upload-cloud" size="16"></vue-feather>
							</div>
							<div class="cmd-body">
								<div class="cmd-text-send">{{ log.command || '—' }}</div>
								<div class="cmd-meta">{{ formatStamp(log.command_sent_at || log.queued_at) }}</div>
							</div>
						</div>

						<div class="cmd-row" v-if="log.response">
							<div class="cmd-icon recv">
								<vue-feather type="download-cloud" size="16"></vue-feather>
							</div>
							<div class="cmd-body">
								<div class="cmd-text-recv">{{ formatResponse(log.response) }}</div>
								<div class="cmd-meta">{{ formatStamp(log.response_at) }}</div>
							</div>
						</div>

						<div class="cmd-row">
							<div class="cmd-icon user">
								<vue-feather type="user" size="16"></vue-feather>
							</div>
							<div class="cmd-body">
								<div class="cmd-user-name">{{ log.user_name || 'Unknown user' }}</div>
								<div class="cmd-ttl" v-if="log.ttl_seconds != null">{{ log.ttl_seconds }}</div>
								<div class="cmd-meta" v-else>TTL —</div>
							</div>
						</div>

						<div class="cmd-footer">
							<span class="cmd-status-pill" :class="log.status || 'queued'">{{ log.status || 'queued' }}</span>
							<span>{{ relativeTime(log.updated_at || log.response_at || log.command_sent_at || log.queued_at) }}</span>
							<vue-feather
								v-if="log.status === 'responded'"
								type="check-circle"
								size="14"
							></vue-feather>
							<vue-feather
								v-else-if="log.status === 'sent'"
								type="check"
								size="14"
							></vue-feather>
							<vue-feather
								v-else
								type="clock"
								size="14"
							></vue-feather>
						</div>
					</div>
				</div>

				<div class="cmd-composer">
					<form class="cmd-composer-row" @submit.prevent="sendCommand">
						<input
							type="text"
							v-model="command"
							:disabled="!selectedImei || sending"
							placeholder="Send Commands here..."
							autocomplete="off"
						/>
						<button class="cmd-send-btn" type="submit" :disabled="!canSend">
							<vue-feather type="send" size="18"></vue-feather>
						</button>
					</form>
					<div class="cmd-hint" v-if="selectedImei">
						Sending to <strong>{{ selectedImei }}</strong>
						<span v-if="polling"> · live updates every {{ pollSeconds }}s</span>
					</div>
					<div class="cmd-hint" v-else>
						Pick an IMEI first to enable sending.
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import moment from 'moment';

export default {
	name: 'SendCommandChat',

	data() {
		return {
			token: '',
			user: null,
			admin: {},
			vehicleQuery: '',
			selectedImei: '',
			selectedVehicleLabel: '',
			selectedDeviceModel: '',
			suggestions: [],
			showSuggestions: false,
			searchTimer: null,
			historyDays: 1,
			logs: [],
			latest: null,
			deviceLastUpdate: null,
			loadingLogs: false,
			sending: false,
			command: '',
			pollTimer: null,
			pollSeconds: 4,
			polling: false,
		};
	},

	computed: {
		authUserId() {
			if (this.admin && this.admin.id != null) return Number(this.admin.id);
			if (this.user && this.user.id != null) return Number(this.user.id);
			return null;
		},

		authRoleId() {
			if (this.admin && this.admin.role_id != null) return Number(this.admin.role_id);
			if (this.user && this.user.role_id != null) return Number(this.user.role_id);
			return null;
		},

		canViewAllCommands() {
			return this.authUserId === 1;
		},

		// Hide server IP suffix only for dealer/company roles (2, 3).
		canViewResponseIp() {
			const roleId = this.authRoleId;
			return roleId != null && roleId !== 2 && roleId !== 3;
		},

		canSend() {
			return Boolean(this.selectedImei)
				&& /^\d{15}$/.test(this.selectedImei)
				&& this.command.trim() !== ''
				&& !this.sending;
		},

		filteredLogs() {
			const cutoff = Date.now() - (Number(this.historyDays) * 24 * 60 * 60 * 1000);
			const currentUserId = this.authUserId;
			const rows = (this.logs || []).filter((log) => {
				if (!this.canViewAllCommands) {
					const logUserId = log.user_id != null ? Number(log.user_id) : null;
					if (logUserId == null || currentUserId == null || logUserId !== currentUserId) {
						return false;
					}
				}

				const stamp = log.updated_at || log.response_at || log.command_sent_at || log.queued_at;
				if (!stamp) return true;
				const ts = new Date(stamp).getTime();
				if (Number.isNaN(ts)) return true;
				return ts >= cutoff;
			});

			// Chat order: oldest first
			return rows.slice().reverse();
		},

		counts() {
			const rows = this.filteredLogs;
			return {
				queued: rows.filter((r) => r.status === 'queued').length,
				sent: rows.filter((r) => r.status === 'sent').length,
				responded: rows.filter((r) => r.status === 'responded').length,
			};
		},

		deviceOnline() {
			if (!this.deviceLastUpdate) return false;
			const ts = new Date(this.deviceLastUpdate).getTime();
			if (Number.isNaN(ts)) return false;
			return (Date.now() - ts) < (10 * 60 * 1000);
		},

		idleLabel() {
			if (!this.deviceLastUpdate) return 'No recent device data';
			const mins = Math.max(0, Math.floor((Date.now() - new Date(this.deviceLastUpdate).getTime()) / 60000));
			if (mins <= 0) return 'Last data just now';
			if (mins === 1) return 'Last data 1 minute ago';
			return `Last data ${mins} minutes ago`;
		},
	},

	mounted() {
		this.getToken();
		this.fetchSettings();
		document.addEventListener('click', this.onDocumentClick);
	},

	beforeUnmount() {
		this.stopPolling();
		if (this.searchTimer) clearTimeout(this.searchTimer);
		document.removeEventListener('click', this.onDocumentClick);
	},

	methods: {
		isPendingStatus(status) {
			return status === 'queued' || status === 'sent';
		},

		fetchSettings() {
			if (!this.getToken()) return;
			this.$axios
				.get('/staffs/settings', this.authHeaders())
				.then((res) => {
					this.admin = res?.data?.data?.admin || {};
				})
				.catch((err) => console.log(err));
		},

		getToken() {
			const raw = localStorage.getItem('airotrack_staff');
			if (!raw) {
				this.$swal('', 'Session expired, please login again', 'error');
				this.$router.push({ name: 'Login' });
				return false;
			}

			const admin = JSON.parse(raw);
			if (!admin.token) {
				this.$swal('', 'Failed to fetch token, please login again', 'error');
				this.$router.push({ name: 'Login' });
				return false;
			}

			this.token = admin.token;
			this.user = admin;
			return true;
		},

		authHeaders(extra = {}) {
			return {
				headers: {
					Accept: 'application/json',
					Authorization: 'Bearer ' + this.token,
					...extra,
				},
			};
		},

		onDocumentClick(e) {
			if (!this.$el.contains(e.target)) {
				this.showSuggestions = false;
			}
		},

		onVehicleQueryInput() {
			this.showSuggestions = true;
			if (this.searchTimer) clearTimeout(this.searchTimer);
			this.searchTimer = setTimeout(() => this.searchVehicles(), 300);
		},

		selectExactImei() {
			const value = (this.vehicleQuery || '').trim().split('|')[0].trim();
			if (/^\d{15}$/.test(value)) {
				this.selectVehicle({ imei: value, vehicle_number: null, device_model: null });
			} else if (this.suggestions.length === 1) {
				this.selectVehicle(this.suggestions[0]);
			}
		},

		searchVehicles() {
			if (!this.getToken()) return;

			const keyword = (this.vehicleQuery || '').trim();
			if (keyword.length < 3) {
				this.suggestions = [];
				return;
			}

			this.$axios
				.get('/staffs/devicesForCommand?keyword=' + encodeURIComponent(keyword), this.authHeaders())
				.then((res) => {
					const rows = res?.data?.data?.devices_for_command || [];
					this.suggestions = rows.slice(0, 20).map((row) => ({
						device_id: row.device_id || null,
						imei: String(row.imei || ''),
						vehicle_number: row.vehicle_number || null,
						device_model: row.device_model || null,
					})).filter((row) => /^\d{15}$/.test(row.imei));
					this.showSuggestions = this.suggestions.length > 0;
				})
				.catch(() => {
					// Fallback: if user typed a full IMEI, allow selecting it directly.
					if (/^\d{15}$/.test(keyword)) {
						this.suggestions = [{ imei: keyword, vehicle_number: null, device_model: null }];
						this.showSuggestions = true;
					} else {
						this.suggestions = [];
					}
				});
		},

		selectVehicle(item) {
			this.selectedImei = item.imei;
			this.selectedVehicleLabel = item.vehicle_number || 'No Vehicle';
			this.selectedDeviceModel = item.device_model || '';
			this.vehicleQuery = item.vehicle_number
				? `${item.imei} | ${item.vehicle_number}`
				: `${item.imei} | No Vehicle`;
			this.showSuggestions = false;
			this.suggestions = [];
			this.logs = [];
			this.latest = null;
			this.fetchDeviceIdle();
			this.fetchLogs(true);
			this.startPolling();
		},

		applyHistoryFilter() {
			this.$nextTick(() => this.scrollChatToBottom());
		},

		fetchDeviceIdle() {
			if (!this.selectedImei || !this.getToken()) return;

			// Prefer Redis live snapshot (same source as live tracking). tc_devices.lastupdate is often stale.
			this.$axios
				.get('/staffs/device-latest?imei=' + encodeURIComponent(this.selectedImei), this.authHeaders())
				.then((res) => {
					const data = res?.data?.data || {};
					this.deviceLastUpdate = data.last_update || data.devicetime || null;
				})
				.catch(() => {
					this.$axios
						.get('/staffs/command_status?limit=1&imei=' + encodeURIComponent(this.selectedImei), this.authHeaders())
						.then((res) => {
							const device = res?.data?.data?.devices?.data?.[0];
							this.deviceLastUpdate = device?.lastupdate || null;
						})
						.catch(() => {
							this.deviceLastUpdate = null;
						});
				});
		},

		fetchLogs(showLoader = false) {
			if (!this.selectedImei || !/^\d{15}$/.test(this.selectedImei)) return;
			if (!this.getToken()) return;

			if (showLoader) this.loadingLogs = true;

			this.$axios
				.get('/staffs/deviceCommandResponse?imei=' + encodeURIComponent(this.selectedImei), this.authHeaders())
				.then((res) => {
					const data = res?.data?.data || {};
					this.latest = data.latest || null;
					if (data.device_last_update) {
						this.deviceLastUpdate = data.device_last_update;
					}
					const logs = Array.isArray(data.logs) ? data.logs : [];

					// Attach latest TTL onto matching log id when available.
					this.logs = logs.map((log) => {
						const stamp = log.updated_at || log.response_at || log.command_sent_at || log.queued_at;
						let ttl = log.ttl_seconds ?? null;
						if (ttl == null && this.latest && this.latest.id && log.id === this.latest.id) {
							ttl = this.latest.ttl_seconds ?? null;
						}
						if (ttl == null && stamp) {
							const expiresAt = new Date(stamp).getTime() + (7 * 24 * 60 * 60 * 1000);
							const remaining = Math.floor((expiresAt - Date.now()) / 1000);
							ttl = remaining > 0 ? remaining : 0;
						}
						return {
							...log,
							ttl_seconds: ttl,
							user_name: log.user_name
								|| (this.latest && this.latest.id === log.id ? this.latest.user_name : null)
								|| null,
						};
					});

					this.$nextTick(() => this.scrollChatToBottom());
				})
				.catch((err) => {
					if (err?.response?.status === 404) {
						this.logs = [];
						this.latest = null;
						return;
					}
					console.log(err);
				})
				.finally(() => {
					this.loadingLogs = false;
				});
		},

		startPolling() {
			this.stopPolling();
			if (!this.selectedImei) return;
			this.polling = true;
			this.pollTimer = setInterval(() => {
				this.fetchLogs(false);
				this.fetchDeviceIdle();
			}, this.pollSeconds * 1000);
		},

		stopPolling() {
			this.polling = false;
			if (this.pollTimer) {
				clearInterval(this.pollTimer);
				this.pollTimer = null;
			}
		},

		sendCommand() {
			if (!this.canSend || !this.getToken()) return;

			const commandText = this.command.trim();
			this.sending = true;

			const formData = new FormData();
			formData.append('imei', this.selectedImei);
			formData.append('command', commandText);

			this.$axios
				.post('/staffs/sendDeviceCommand', formData, this.authHeaders({
					'Content-type': 'multipart/form-data',
				}))
				.then((response) => {
					if (response?.data?.status) {
						this.command = '';
						// Optimistic local bubble until poll refreshes.
						this.logs = [
							{
								id: response.data.data?.log_id || ('local-' + Date.now()),
								command: commandText,
								response: null,
								user_id: response.data.data?.user_id || this.authUserId,
								user_name: this.admin?.user_name || this.user?.user_name || this.user?.name || 'You',
								status: 'queued',
								queued_at: response.data.data?.datetime || this.nowStamp(),
								command_sent_at: null,
								response_at: null,
								updated_at: response.data.data?.datetime || this.nowStamp(),
								ttl_seconds: null,
							},
							...this.logs,
						];
						this.$nextTick(() => this.scrollChatToBottom());
						this.fetchLogs(false);
					} else {
						this.$swal('', response?.data?.message || 'Failed to queue command', 'error');
					}
				})
				.catch((error) => {
					const message = error?.response?.data?.message;
					if (typeof message === 'string') {
						this.$swal('', message, 'error');
					} else {
						this.$swal('', 'Failed to send command', 'error');
					}
				})
				.finally(() => {
					this.sending = false;
				});
		},

		scrollChatToBottom() {
			const el = this.$refs.chatBox;
			if (el) el.scrollTop = el.scrollHeight;
		},

		nowStamp() {
			const d = new Date();
			const pad = (n) => String(n).padStart(2, '0');
			return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
		},

		formatStamp(value) {
			if (!value) return '';
			return moment.utc(value).format('DD MMM YYYY, hh:mm:ss A');
		},

		formatResponse(value) {
			if (!value) return '';
			// Admin (role_id 1) and staffs (5, 6, 7, …) see full response including server IP.
			if (this.canViewResponseIp) {
				return String(value);
			}
			// role_id 2 / 3: hide trailing IP, e.g. "U:http://68.183.244.95" or "0U:http://..."
			return String(value)
				.replace(/(?:[,;]\s*)?(?:0U|OU|U):https?:\/\/\S+$/i, '')
				.replace(/[,;]\s*$/, '')
				.trim();
		},

		relativeTime(value) {
			if (!value) return '';
			const ts = new Date(value).getTime();
			if (Number.isNaN(ts)) return '';
			const diffSec = Math.max(0, Math.floor((Date.now() - ts) / 1000));
			if (diffSec < 60) return `${diffSec} seconds ago`;
			const mins = Math.floor(diffSec / 60);
			if (mins < 60) return mins === 1 ? '1 minute ago' : `${mins} minutes ago`;
			const hours = Math.floor(mins / 60);
			if (hours < 24) return hours === 1 ? '1 hour ago' : `${hours} hours ago`;
			const days = Math.floor(hours / 24);
			return days === 1 ? '1 day ago' : `${days} days ago`;
		},
	},
};
</script>
